export const createGetBrandKitRequest = () => {
  return {
    url: "/brand_kits",
    method: "GET",
  };
};

export const createGetBrandKitByIdRequest = (id) => {
  return {
    url: `/brand_kits/${id}`,
    method: "GET",
  };
};

export const createSaveBrandKitRequest = (data) => {
  return {
    url: "/brand_kits",
    method: "POST",
    data,
  };
};

export const createUpdateBrandKitRequest = (id, data) => {
  return {
    url: `/brand_kits/${id}`,
    method: "PUT",
    data,
  };
};

export const createDeleteBrandKitRequest = (id) => {
  return {
    url: `/brand_kits/${id}`,
    method: "DELETE",
  };
};
